import { Box, Link, Stack, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function UnScheduleList({ list, permission }) {
  const { t } = useTranslation()

  if (!list?.length) return null

  return (
    <Box sx={{ mt: 3, pb: 2 }}>
      <Typography variant="subtitle2" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.04em' }}>
        {t('Unscheduled Course Sessions')}
      </Typography>
      <Stack sx={{ mt: 1 }} spacing={0.5}>
        {list.map((item, index) => {
          const label = [item?.courseSession?.course?.name, item?.courseSession?.name]
            .filter(Boolean)
            .join(' - ')

          return (
            <Typography key={index} variant="body2">
              {permission && item?.courseSession?.id ? (
                <Link
                  component={NavLink}
                  to={`/settings/scheduling/course-sessions/${item.courseSession.id}`}
                  underline="hover"
                  color="inherit"
                  sx={{ '@media print': { color: 'inherit', textDecoration: 'none' } }}
                >
                  {label}
                </Link>
              ) : (
                label
              )}
            </Typography>
          )
        })}
      </Stack>
    </Box>
  )
}
